import React, { memo } from "react";
import PropTypes from "prop-types";
import { AlertDescription } from "@chakra-ui/react";
import Alert from "../Alert/Alert";
import * as PostEditorErrorLevels from "./PostEditorErrorLevels.constants";

const statusesMap = {
  [PostEditorErrorLevels.ERROR]: "error",
  [PostEditorErrorLevels.WARNING]: "warning",
  [PostEditorErrorLevels.INFO]: "info",
}

const PostEditorError = ({ message, level = PostEditorErrorLevels.ERROR }) =>  (
  <Alert status={statusesMap[level]} showIcon>
    <AlertDescription
      lineHeight="inherit"
      dangerouslySetInnerHTML={{
        __html: message,
      }}
    />
  </Alert>
);

PostEditorError.propTypes = {
  message: PropTypes.string.isRequired,
  level: PropTypes.oneOf(Object.values(PostEditorErrorLevels)),
};

PostEditorError.defaultProps = {
  level: undefined,
};

export default memo(PostEditorError);
